import httpService from "./httpService";
import jwtDecode from 'jwt-decode'

const apiEndpoint = process.env.REACT_APP_BACKEND_API_PATH

const tokenKey = "token"

httpService.responseInterceptor.use(null, error => {
    if (error.response) {
        if (error.response.status == 403) {
            redirectToLoginIfTokenExpired();
        }
    }
    return Promise.reject(error);
})

function redirectToLoginIfTokenExpired() {
    if (!isJwtStillValid()) {
        if (getCurrentUser() != null) {
            window.location = '/login'
            logout();
        }
    }
}
httpService.setJwt(getJwt())

redirectToLoginIfTokenExpired();

function isJwtStillValid() {
    const currentUser = getCurrentUser()
    const now = Date.now();
    if (currentUser) {
        if (currentUser.exp * 1000 < now) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

function getCurrentUser() {
    try {
        const jwt = localStorage.getItem(tokenKey)
        const user = jwtDecode(jwt)
        return user;
    } catch (ex) {
        return null;
    }
}

function storeJwt(token) {
    localStorage.setItem(tokenKey, token)
    httpService.setJwt(token)
}

function authenticate(username, password) {
    return httpService.post(apiEndpoint + '/authenticate', new URLSearchParams({
        username,
        password
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function registerUser(username, email, password) {
    return httpService.post(apiEndpoint + '/register', new URLSearchParams({
        username,
        email,
        password
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function updateUserDetails(profilePic, bannerPic, deleteProfile, deleteBanner, bio) {
    const formData = new FormData();
    formData.append('profile', profilePic)
    formData.append('banner', bannerPic)
    formData.append('deleteProfile', deleteProfile)
    formData.append('deleteBanner', deleteBanner)
    formData.append('bio', bio)
    return httpService.post(apiEndpoint + '/profile/update', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

function getUserDetails(username) {
    return httpService.get(apiEndpoint + `/profile/${username}`)
}

function logout() {
    localStorage.removeItem(tokenKey)
    httpService.setJwt('')
}

function getJwt() {
    return localStorage.getItem(tokenKey)
}

function toggleUserBan(username) {
    return httpService.post(apiEndpoint + '/admin/ban', new URLSearchParams({
        username,
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function getUsers() {
    return httpService.get(apiEndpoint + `/admin/users`)
}

function getStatistics(code) {
    return httpService.get(apiEndpoint + `/admin/statistics/users`, {
        params: {
            code,
        },
    })
}

function getTickets() {
    return httpService.get(apiEndpoint + `/admin/tickets`)
}


function followUser(username) {
    return httpService.post(apiEndpoint + `/profile/${username}/follow`)
}

function getFollowers(username) {
    return httpService.get(apiEndpoint + `/profile/${username}/followers`)
}


function getBasicDetails() {
    return httpService.get(apiEndpoint + `/settings/basic`)
}

function updateBasicDetails(email) {
    return httpService.post(apiEndpoint + `/settings/basic/update`, new URLSearchParams({
        email,
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function updatePassword(password, confirmPassword) {
    return httpService.post(apiEndpoint + `/settings/security/update`, new URLSearchParams({
        password,
        confirmPassword
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

function submitContactTicket(title, description) {
    return httpService.post(apiEndpoint + `/contact`, new URLSearchParams({
        title,
        description
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}
export default {
    getCurrentUser,
    storeJwt,
    authenticate,
    registerUser,
    updateUserDetails,
    getUserDetails,
    logout,
    getJwt,
    isJwtStillValid,
    toggleUserBan,
    getUsers,
    getStatistics,
    getTickets,
    followUser,
    getFollowers,
    getBasicDetails,
    updateBasicDetails,
    updatePassword,
    submitContactTicket
}